// Функция для алфавитно-цифровой сортировки товаров
export const sortProductsAlphanumeric = <T extends { name: string }>(products: T[]): T[] => {
  return [...products].sort((a, b) => {
    const nameA = a.name || '';
    const nameB = b.name || '';
    
    // Извлекаем текст до цифр
    const textA = nameA.replace(/[0-9].*/, '');
    const textB = nameB.replace(/[0-9].*/, '');
    
    // Извлекаем число из названия
    const numberA = parseInt(nameA.match(/[0-9]+/)?.[0] || '0');
    const numberB = parseInt(nameB.match(/[0-9]+/)?.[0] || '0');
    
    // Сначала сортируем по тексту
    if (textA !== textB) {
      return textA.localeCompare(textB);
    }
    
    // Если текст одинаковый, сортируем по числу
    if (numberA !== numberB) {
      return numberA - numberB;
    }
    
    // Если и текст, и число одинаковые, сортируем по полному названию
    return nameA.localeCompare(nameB);
  });
};

// Функция для сортировки категорий
export const sortCategoriesAlphanumeric = <T extends { name: string }>(categories: T[]): T[] => {
  return [...categories].sort((a, b) => {
    const nameA = a.name || '';
    const nameB = b.name || '';
    
    // Извлекаем текст до цифр
    const textA = nameA.replace(/[0-9].*/, '');
    const textB = nameB.replace(/[0-9].*/, '');
    
    // Извлекаем число из названия
    const numberA = parseInt(nameA.match(/[0-9]+/)?.[0] || '0');
    const numberB = parseInt(nameB.match(/[0-9]+/)?.[0] || '0');
    
    // Сначала сортируем по тексту
    if (textA !== textB) {
      return textA.localeCompare(textB);
    }
    
    // Если текст одинаковый, сортируем по числу
    if (numberA !== numberB) {
      return numberA - numberB;
    }
    
    // Если и текст, и число одинаковые, сортируем по полному названию
    return nameA.localeCompare(nameB);
  });
};
